import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { BaseService } from './BaseService';
import { MasterDataService } from '../Services/MasterDataService';
import * as enumModels from '../Models/EnumModels';
import { isEmpty } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { AppSettings } from '../Library/AppSettings';

@Injectable()
export class AuthGuardService extends BaseService implements CanActivate {

    constructor(private router: Router, public masterService: MasterDataService,public cookieService : CookieService) {
        super();
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const deviceCookie = this.cookieService.get('IdentifierToken');
        const isPropertyAdmin = this.masterService.LoggedInUserData.IsPropertyAdmin;

        if (!isPropertyAdmin && AppSettings.WebSecurity && !deviceCookie) {
            console.info('AuthGuardService - Skip Check');
            this.router.navigateByUrl('');
            return false;
        }
        
        if (route.data.SelectedModule == enumModels.Modules.NoService) {
            let LicensedProperties = this.masterService.GetProperties_ModuleLicence(enumModels.ModuleLicenceCodes.TritonRapidResponse);
            if (LicensedProperties.length > 0) {
                return true;
            }
            else {
                this.router.navigate(['home/Glitch/GlitchConsole']);
                return false;
            }
        }
        else if (route.data.SelectedModule == enumModels.Modules.Glitch) {
            let LicensedProperties = this.masterService.GetProperties_ModuleLicence(enumModels.ModuleLicenceCodes.TritonGlitch);
            if (LicensedProperties.length > 0) {
                return true;
            }
            else {
                this.router.navigate(['home/Guests/CurrentReservationConsole']);
                return false;
            }
        }
        else if (route.data.SelectedModule == enumModels.Modules.Guests) {
            let LicensedProperties = this.masterService.GetProperties_ModuleLicence(enumModels.ModuleLicenceCodes.TritonFrontOffice);
            if (LicensedProperties.length > 0) {
                return true;
            }
            else {
                this.router.navigate(['home/Welcome']);
                return false;
            }
        }
        else if (route.data.SelectedModule == enumModels.Modules.StaffHealth) {
            let LicensedProperties = this.masterService.GetProperties_Action(
                enumModels.AuthActionCodes.StaffHealth_MANAGE
            );

            if (LicensedProperties.length > 0 || this.masterService.LoggedInUserData.IsPropertyAdmin) {
                return true;
            }
            else {
                this.router.navigate(['home/Welcome']);
                return false;
            }
        }
        else if (route.data.SelectedModule == enumModels.Modules.ServiceAnalytics) {
            let LicensedProperties = this.masterService.GetProperties_Action(
                enumModels.AuthActionCodes.CreateAdvancedKnowServiceReports
            );

            if (LicensedProperties.length > 0 || this.masterService.LoggedInUserData.IsPropertyAdmin) {
                return true;
            }
            else {
                this.router.navigate(['home/Welcome']);
                return false;
            }
        }
        else if (route.data.SelectedModule == enumModels.Modules.GlitchAnalytics) {
            let LicensedProperties = this.masterService.GetProperties_Action(
                enumModels.AuthActionCodes.CreateKnowGlitchReports
            );

            if (LicensedProperties.length > 0 || this.masterService.LoggedInUserData.IsPropertyAdmin) {
                return true;
            }
            else {
                this.router.navigate(['home/Welcome']);
                return false;
            }
        } else if (route.data.SelectedModule == enumModels.Modules.HKAnalytics) {
            let LicensedProperties = this.masterService.GetProperties_Action(
                enumModels.AuthActionCodes.EditHKReports
            );

            if (LicensedProperties.length > 0 || this.masterService.LoggedInUserData.IsPropertyAdmin) {
                return true;
            }
            else {
                this.router.navigate(['home/Welcome']);
                return false;
            }
        }
    }

}
